#import "../../common/graphql/SecureRowLevelsEntityFields.graphql"
query PurchaseOrderCommonData {
  companyPurchaseOrderTypes(orderBy: [IS_DEFAULT_DESC, SORT_ORDER_ASC]) {
    nodes {
      id
      purchaseOrderTypeId
      purchaseOrderType
      layoutType
      isUserTemplateAllowed
      isPunchoutProcessing
      isProtectedFromUpdate
      isDefault
      isCreateEntryAllowed
      distributionLayoutType
      companyPurchaseOrderItemTypes(orderBy: SORT_ORDER_ASC) {
        nodes {
          purchaseOrderItemTypeId
          description
          isExpenditureTypeAllowed
          isExpenditureTypeRequired
          isOrderItemSelectable
          isQuantityAllowed
          isAutoCalculated
          isTaxAllowed
          isDiscountAllowed
          isUnitOfMeasureRequired
          isDelivery
          isDiscount
          isTax
          calculationType
          layoutType
          unitOfMeasureGroup {
            unitOfMeasureItemsByUnitOfMeasureGroupId(orderBy: SORT_ORDER_ASC) {
              nodes {
                id
                unitOfMeasureItem
                calculationType
                isDateDurationAddAllowed
                abbreviation
                partialAbbreviation
              }
            }
            expenditureTypes(orderBy: SORT_ORDER_ASC) {
              nodes {
                id
                expenditureType
              }
            }
          }
        }
      }
    }
  }
  expenditureTypes(
    filter: {
      isPurchaseOrderSelectable: { equalTo: true }
      unitOfMeasureGroupId: { isNull: true }
    }
  ) {
    nodes {
      id
      expenditureType
    }
  }
  taxTypes {
    nodes {
      id
      taxType
    }
  }
  companyCurrencies {
    nodes {
      id
      name
      isoCode
    }
  }
  companyBusinessUnits (orderBy: NAME_ASC){
    nodes {
      id
      name
      companyAddress {
        addressAlias
        addressLine1
        addressLine2
        cityName
        postalCode
      }
    }
  }
  companyDepartments(
    orderBy: [NAME_ASC, PRIMARY_KEY_ASC]
    filter: { _isSystemInternal: { notEqualTo: true } }
  ) {
    nodes {
      id
      name
      _isPoSelectable
      userDepartment {
        _isUserAssigned
      }
    }
  }
  companies(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  tax1099T4Types {
    nodes {
      id
      tax1099T4Type
      abbreviation
    }
  }
  projects {
    nodes {
      id
      name
      code
    }
  }
  productionIncentives {
    nodes {
      id
      incentiveType {
        incentiveType
      }
      _fullDescription
    }
  }
  companyCurrencies {
    nodes {
      id
      name
    }
  }
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
}
